import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css';
import 'animate.css/animate.compat.css';
import "./index.css";
import Vue from "vue";
import App from "./Careers.vue";

(function () {
    "use strict";
    new Vue({
        render: (h) => h(App),
    }).$mount("#app");
})();


